/* URBAN MODESTY — CRO layer
   1. Free-shipping progress bar in the cart drawer (live via cart:updated)
   2. Sticky add-to-cart bar on product pages, with size selection
      mirrored from (and synced to) the main product form
   3. Quick add-by-size on collection/grid product cards
*/
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------------------------------------------------------------
     1. Free shipping progress
  ----------------------------------------------------------------*/
  function initShippingBar() {
    var bar = document.querySelector('[data-um-shipbar]');
    if (!bar) return;

    var threshold = (window.theme && theme.settings && theme.settings.freeShippingThreshold) || 9900;
    var fill = bar.querySelector('.um-shipbar__fill');
    var label = bar.querySelector('.um-shipbar__label');

    function update(cart) {
      if (!cart || typeof cart.total_price !== 'number') return;
      var total = cart.total_price;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      fill.style.width = pct + '%';

      if (cart.item_count === 0) {
        bar.classList.remove('um-shipbar--unlocked');
        label.innerHTML = 'Free U.S. shipping on orders over <strong>' + formatMoney(threshold) + '</strong>';
      } else if (total >= threshold) {
        bar.classList.add('um-shipbar--unlocked');
        label.innerHTML = '<strong>Congratulations</strong> — your order ships free';
      } else {
        bar.classList.remove('um-shipbar--unlocked');
        label.innerHTML = 'You are <strong>' + formatMoney(threshold - total) + '</strong> away from free shipping';
      }
    }

    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.cart) update(evt.detail.cart);
    });

    fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js')
      .then(function (r) { return r.json(); })
      .then(update)
      .catch(function () {});
  }

  /* ---------------------------------------------------------------
     2. Sticky add to cart (product pages)
  ----------------------------------------------------------------*/
  function initStickyAtc() {
    var stickyBar = document.querySelector('[data-um-sticky-atc]');
    if (!stickyBar || !('IntersectionObserver' in window)) return;

    var realBtn = document.querySelector('.product-single__form [data-add-to-cart]');
    if (!realBtn) { stickyBar.remove(); return; }

    var scope = realBtn.closest('[data-section-type="product"]') ||
                realBtn.closest('.product-section') ||
                document;

    var stickyBtn = stickyBar.querySelector('[data-um-sticky-btn]');
    var stickyBtnText = stickyBar.querySelector('[data-um-sticky-btn-text]');
    var priceEl = stickyBar.querySelector('[data-um-sticky-price]');
    var realBtnText = realBtn.querySelector('[data-add-to-cart-text]');

    /* --- Button state: mirror text/disabled without copying markup --- */
    function currentRealText() {
      return realBtnText ? realBtnText.textContent.replace(/\s+/g, ' ').trim()
                         : realBtn.textContent.replace(/\s+/g, ' ').trim();
    }

    function syncButton() {
      stickyBtn.disabled = realBtn.disabled;
      var text = currentRealText();
      if (text) stickyBtnText.textContent = text;
    }
    syncButton();
    new MutationObserver(syncButton).observe(realBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });

    stickyBtn.addEventListener('click', function () {
      realBtn.click();
    });

    /* --- Size chips: mirror the main form's Size option --- */
    var sizesWrap = stickyBar.querySelector('[data-um-sticky-sizes]');
    var chipPairs = []; // { chip, input }

    (function buildSizeChips() {
      if (!sizesWrap) return;
      var sizeFieldset = null;
      var fieldsets = scope.querySelectorAll('fieldset.variant-input-wrap');
      for (var i = 0; i < fieldsets.length; i++) {
        var handle = fieldsets[i].getAttribute('data-handle') || '';
        if (handle.indexOf('size') !== -1) { sizeFieldset = fieldsets[i]; break; }
      }
      if (!sizeFieldset) return;

      var inputs = sizeFieldset.querySelectorAll('.variant-input input[type="radio"]');
      if (inputs.length < 2) return;

      inputs.forEach(function (input) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'um-sticky-atc__chip';
        chip.textContent = input.value;
        chip.addEventListener('click', function () {
          if (!input.checked) input.click();
          syncChips();
        });
        sizesWrap.appendChild(chip);
        chipPairs.push({ chip: chip, input: input });
      });

      syncChips();
      sizesWrap.hidden = false;
    })();

    function chipUnavailable(pair) {
      var label = pair.input.nextElementSibling;
      return pair.input.classList.contains('disabled') ||
             pair.input.disabled ||
             (label && label.classList.contains('disabled'));
    }

    function syncChips() {
      var visible = 0;
      chipPairs.forEach(function (pair) {
        var out = chipUnavailable(pair);
        pair.chip.hidden = out;
        if (!out) visible++;
        pair.chip.classList.toggle('is-active', pair.input.checked);
      });
      if (sizesWrap) sizesWrap.hidden = visible < 2;
    }

    /* --- Price + state sync on variant change --- */
    document.addEventListener('variant:change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (variant && priceEl) {
        // Money format may contain markup (e.g. <span class=money>),
        // so it must be rendered as HTML, not text
        priceEl.innerHTML = formatMoney(variant.price);
      }
      if (chipPairs.length) syncChips();
      syncButton();
    });

    /* --- Visibility --- */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
    }, { threshold: 0 });

    observer.observe(realBtn);
  }

  /* ---------------------------------------------------------------
     3. Quick add-by-size on product grid cards
        Markup rendered by snippets/um-quick-add.liquid.
  ----------------------------------------------------------------*/
  function initQuickAdd() {
    document.addEventListener('click', function (evt) {
      var toggle = evt.target.closest && evt.target.closest('[data-um-qa-toggle]');
      if (toggle) {
        evt.preventDefault();
        evt.stopPropagation();
        var qaBox = toggle.closest('[data-um-qa]');
        var open = qaBox.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      var chip = evt.target.closest && evt.target.closest('[data-um-quick-add]');
      if (!chip) return;

      evt.preventDefault();
      evt.stopPropagation();
      if (chip.classList.contains('is-loading')) return;

      var qa = chip.closest('[data-um-qa]');
      var variantId = parseInt(chip.getAttribute('data-variant-id'), 10);
      if (!variantId) return;

      chip.classList.add('is-loading');

      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          chip.classList.remove('is-loading');

          if (data && data.status && data.status !== 200) {
            // e.g. just sold out, or cart quantity limit reached
            chip.classList.add('is-error');
            setTimeout(function () { chip.classList.remove('is-error'); }, 1600);
            return;
          }

          chip.classList.add('is-added');
          setTimeout(function () { chip.classList.remove('is-added'); }, 1200);

          if (qa) {
            var idInput = qa.querySelector('input[name="id"]');
            if (idInput) idInput.value = variantId;
            qa.classList.remove('is-open');
            // Let the theme rebuild + open the cart drawer
            qa.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: data, addToCartBtn: chip },
              bubbles: true
            }));
          }
        })
        .catch(function () {
          chip.classList.remove('is-loading');
          chip.classList.add('is-error');
          setTimeout(function () { chip.classList.remove('is-error'); }, 1600);
        });
    });

    // Close any open mobile quick-add when tapping elsewhere
    document.addEventListener('touchstart', function (evt) {
      document.querySelectorAll('[data-um-qa].is-open').forEach(function (qa) {
        if (!qa.contains(evt.target)) qa.classList.remove('is-open');
      });
    }, { passive: true });
  }

  function init() {
    initShippingBar();
    initStickyAtc();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
